export const getObject = (object: any, path: string) => {
  const keys = path.split(".");
  let result = object;
  for (const key of keys) {
    result = result?.[key] ?? null;
  }
  return result;
};

export const createUtcDate = (str?): Date => {
  let obj;
  if (!str) {
    obj = new Date();
  } else {
    obj = new Date(str);
  }

  // hack for safari
  // it can create date from 'Y-m-d H:i:s', it only create for 'Y-m-d'
  if (isNaN(obj.getTime()) && typeof str === 'string') {
    const matchResult = str.match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/);
    if (matchResult) {
      obj = new Date(`${matchResult[1]}-${matchResult[2]}-${matchResult[3]}`);
    }
  }

  const day = obj.getDate();
  const month = obj.getMonth();
  const year = obj.getFullYear();

  return new Date(Date.UTC(year, month, day));
}
